import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const ConfigureQuickTeamsRoute = lazyWithRetries(() => import('./configure/ConfigureQuickTeams'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.configureQuickTeams(),
    element: (
      <StandardPageLayout
        elementId="teamConfigurationRoute"
        title={<T _str="Team configuration" />}
        maxWidth={900}>
        <Suspense fallback={<RouteLoading />}>
          <ConfigureQuickTeamsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
